import React, { FC } from 'react';
import styles from './MaintenanceTriggerForm.module.scss';
import { Button } from 'antd';

type Props = {
  isCloning: boolean;
  canClone: boolean;
  onClone: () => void;
};

export const Header: FC<Props> = ({ isCloning, canClone, onClone }) => {
  return (
    <div className={styles.maintenanceHeader}>
      <h4>Maintenance trigger definition</h4>
      {canClone && (
        <Button loading={isCloning} type='default' onClick={onClone}>
          Clone
        </Button>
      )}
    </div>
  );
};

export default Header;
